import { type FC } from 'react';
import classes from '../styles/index.module.css';
import { ToolNavigationCollapsedList } from './ToolNavigationCollapsedList';
import { useToolNavigationDataProvider } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationDataProvider';
import { useToolNavigationRoleSwitcherProvider } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationRoleSwitcherProvider';
import { ToolNavigationCollapsedRoleSwitcher } from './ToolNavigationCollapsedRoleSwitcher';
import { ToolNavigationCollapsedFooter } from './ToolNavigationCollapsedFooter';

export const ToolNavigationCollapsedContent: FC = () => {
	const { isAdmin } = useToolNavigationRoleSwitcherProvider();
	const navData = useToolNavigationDataProvider();
	const adminNavigationItems = navData?.adminNavigationItems || [];
	const userNavigationItems = navData?.userNavigationItems || [];

	return (
		<div className={classes.toolNavigation__collapsedMenu}>
			<ToolNavigationCollapsedRoleSwitcher />
			<ToolNavigationCollapsedList items={isAdmin ? adminNavigationItems : userNavigationItems} />
			<ToolNavigationCollapsedFooter />
		</div>
	);
};
